<template>
  <div class="dialog-wrap">
    <el-dialog title="积分明细"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               @open="open()"
               width="570px">
      <div>
        <el-form class="search-wrap"
                 ref="searchForm"
                 :inline="true"
                 :model="query"
                 style="display:flex">
          <el-form-item label="积分加分类型"
                        prop="status">
            <el-select v-model="query.in_point_types"
                       placeholder="请选择"
                       clearable
                       @change="getInterList(true)"
                       style="width:150px;">
              <el-option v-for="item in filter.inPointType"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="积分减分类型"
                        prop="status">
            <el-select v-model="query.out_point_types"
                       placeholder="请选择"
                       clearable
                       @change="getInterList(true)"
                       style="width:150px;">
              <el-option v-for="item in filter.outPointType"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-table :data="results"
                  border
                  style="width: 100%">
          <el-table-column type="index"
                           label="序号"
                           width="50"
                           align="center">
          </el-table-column>
          <el-table-column label="记录时间"
                           align="center"
                           width="100"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.create_time
                  ? $moment(scope.row.create_time).format("YYYY-MM-DD")
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column label="变动分数"
                           align="center"
                           width="100"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.type==1">+{{scope.row.point}}</span>
              <span v-if="scope.row.type==2">-{{scope.row.point}}</span>
            </template>
          </el-table-column>
          <el-table-column label="变动原因"
                           align="center"
                           width="150"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.in_point_type==1">完成学长认证</span>
              <span v-if="scope.row.in_point_type==2">发布经验</span>
              <span v-if="scope.row.in_point_type==3">发布看法</span>
              <span v-if="scope.row.in_point_type==4">发布免费资料</span>
              <span v-if="scope.row.in_point_type==5">发布免费视频</span>
              <span v-if="scope.row.in_point_type==6">对求助贴发布评论</span>
              <span v-if="scope.row.in_point_type==7">完成学长入门任务</span>
              <span v-if="scope.row.in_point_type==8">笔记被赞或收藏</span>
              <span v-if="scope.row.in_point_type==9">笔记被评论</span>
              <span v-if="scope.row.in_point_type==10">邀请用户注册</span>
              <span v-if="scope.row.in_point_type==11">推荐用户下单</span>
              <span v-if="scope.row.in_point_type==12">完成个人信息填写</span>
              <span v-if="scope.row.in_point_type==13">发布求助贴</span>
              <span v-if="scope.row.in_point_type==14">完成用户入门任务</span>
              <span v-if="scope.row.in_point_type==15">评论审核发放积分</span>
            </template>
          </el-table-column>
          <el-table-column label="备注"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.remark}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div style="marginTop:10px"><el-pagination background
                         layout="total, prev, pager, next, sizes, jumper"
                         :current-page="Number(query.pageIndex)"
                         :page-sizes="[10, 20, 50, 100, 500]"
                         :page-size="Number(query.pageSize)"
                         :total="Number(pageTotal)"
                         @size-change="handleSizeChange"
                         @current-change="handlePageChange">
          </el-pagination></div>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import { integralList } from '@/api/senior'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: Number,
      default: () => {
        return null
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      results: [],
      pageTotal: 0,
      filter: {
        inPointType: [
          {
            label: '完成学长认证',
            value: '1',
          },
          {
            label: '发布经验',
            value: '2',
          },
          {
            label: '发布看法',
            value: '3',
          },
          {
            label: '发布免费资料',
            value: '4',
          },
          {
            label: '发布免费视频',
            value: '5',
          },
          {
            label: '对求助贴发布评论',
            value: '6',
          },
          {
            label: '完成学长入门任务',
            value: '7',
          },
          {
            label: '笔记被赞或收藏',
            value: '8',
          },
          {
            label: '笔记被评论',
            value: '9',
          },
          {
            label: '邀请用户注册',
            value: '10',
          },
          {
            label: '推荐用户下单',
            value: '11',
          },
          {
            label: '完成个人信息填写',
            value: '12',
          },
          {
            label: '发布求助贴',
            value: '13',
          },
          {
            label: '完成用户入门任务',
            value: '14',
          },
          {
            label: '评论审核发放积分',
            value: '15',
          },
        ],
        outPointType: [
          {
            label: '发布违规或重复评论',
            value: '1',
          },
          {
            label: '笔记审核扣减积分',
            value: '2',
          },
          {
            label: '评论审核扣减积分',
            value: '3',
          },
        ],
      },
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
  },
  methods: {
    handleClose() {
      this.results = []
      this.pageTotal = 0
      this.query.pageIndex = 1
      this.$emit('close')
    },
    open() {
      this.getInterList()
    },
    getInterList() {
      this.query.uid = this.rowId
      integralList(this.query).then((res) => {
        this.results = res.list || []
        console.log('this.result', this.results)
        this.pageTotal = res.count
      })
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.getInterList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.getInterList()
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep .el-dialog__header {
  background: #ecf2fe;
}
::v-deep .custon-textarea .el-textarea__inner {
  min-height: 100px !important;
}
.dialog-wrap {
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
}
/deep/.el-upload {
  width: 122px;
  height: 122px;
  line-height: 122px;
}
/deep/.el-upload-list__item {
  width: 122px;
  height: 122px;
}
</style>
